import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { RelationSearch, type RelationPick } from './RelationSearch'
import type { CaptureContext } from './types'
import { useRelationName } from './useRelationName'

/**
 * "Als notitie bewaren bij … ▾": the transcript as one note at a relation, without the AI. The
 * relation the memo started from is offered first; anyone else is found by searching.
 */
export function SaveAsNote({
  label,
  context,
  disabled,
  onSave,
}: {
  label: string
  context: CaptureContext | null
  disabled?: boolean
  onSave: (target: { type: 'contact' | 'organisatie'; id: string }) => void
}) {
  const [open, setOpen] = useState(false)
  const contextName = useRelationName(context)
  const choose = (pick: Pick<RelationPick, 'type' | 'id'>) => {
    setOpen(false)
    onSave({ type: pick.type, id: pick.id })
  }
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled ?? false}>
          {label}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 space-y-3 p-3">
        {context ? (
          <Button type="button" variant="outline" className="w-full" onClick={() => choose({ type: context.type, id: context.id })}>
            {contextName ?? 'De relatie van dit verslag'}
          </Button>
        ) : null}
        <RelationSearch label="Zoek de relatie voor de notitie" onPick={choose} />
      </PopoverContent>
    </Popover>
  )
}
